export type { DataSMSCode } from '~services/interfaces'

export enum MethodEnum {
  SMS = 'sms',
  WHATSAPP = 'whatsapp',
}

export interface Values {
  token: string[]
}

export type Params = [string, string, string, string, string]
